export default "__VITE_ASSET__c3ba4d5a__"